module.exports = __webpack_public_path__ + "media/images/sprite-social-3ad82aa713327d1dc8ad66cedece844b.svg";